import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const GalleryNavigationBreadcrumb = ({ 
  items = [],
  userRole = 'visitor'
}) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    if (path) {
      navigate(path);
    }
  };

  if (!items || items?.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumb-container" aria-label="Breadcrumb navigation">
      {items?.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon 
              name="ChevronRight" 
              size={16} 
              className="breadcrumb-separator"
            />
          )}
          <div 
            className={`breadcrumb-item ${index === items?.length - 1 ? 'active' : ''}`}
            onClick={() => item?.path && handleNavigate(item?.path)}
            style={{ cursor: item?.path ? 'pointer' : 'default' }}
          >
            {item?.icon && (
              <Icon name={item?.icon} size={16} />
            )}
            <span>{item?.label}</span>
          </div>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default GalleryNavigationBreadcrumb;